import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: "background.paper",
  border: "4px transparent #000",
  boxShadow: 24,
  p: 4,
  borderRadius: ".5rem",
};

const ActionButton = styled(Button)({
  fontFamily: "Poppins",
  backgroundColor: "#21357B",
  margin: "10px",
  textTransform: "none",
});

export default function DuplicateEmployeeModal({
  isOpen,
  handleClose,
  duplicateEmployee,
  onReassign,
  onContinue,
}) {
  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box sx={style}>
        <h3>Duplicate Employee Found</h3>
        <p>An inactive employee with the same name was found:</p>
        <div style={{ margin: "20px 0" }}>
          <p>
            <strong>Name:</strong> {duplicateEmployee?.firstName}{" "}
            {duplicateEmployee?.lastName}
          </p>
          <p>
            <strong>Previous Company:</strong> {duplicateEmployee?.companyName}
          </p>
        </div>
        <p>Would you like to reassign this employee or create a new one?</p>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          <ActionButton onClick={onContinue} variant="contained">
            Create
          </ActionButton>
          <ActionButton onClick={onReassign} variant="contained">
            Reassign
          </ActionButton>
        </div>
      </Box>
    </Modal>
  );
}
